const copyText = async (text) => {
	if (navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(text);
		return;
	}

	const field = document.createElement("textarea");
	field.value = text;
	field.setAttribute("readonly", "");
	field.style.position = "fixed";
	field.style.opacity = "0";
	document.body.appendChild(field);
	field.select();
	const copied = document.execCommand("copy");
	field.remove();
	if (!copied) throw new Error("copy failed");
};

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".article-share-button.is-copy").forEach((button) => {
		const status = button.closest(".article-share-buttons")?.querySelector(".article-share-status");
		let timer = null;

		button.addEventListener("click", async () => {
			const url = button.dataset.url || window.location.href;

			try {
				await copyText(url);
			} catch {
				window.prompt(button.getAttribute("aria-label") || "", url);
				return;
			}

			if (!status) return;
			status.textContent = status.dataset.message || "";
			clearTimeout(timer);
			timer = setTimeout(() => {
				status.textContent = "";
			}, 3000);
		});
	});
});
